import { render, staticRenderFns } from "./modal-add.vue?vue&type=template&id=7d8568e4&"
import script from "./modal-add.vue?vue&type=script&lang=js&"
export * from "./modal-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports